<template>
  <section class="sheet">
    <div style="font-family:Roboto, Helvetica, Arial; padding-top:5mm;">
      <!-- background-image: url(http://localhost:6161/logo); background-position:220px 180px; background-repeat: no-repeat; background-size: 400px; -->
      <!-- <img style="display: block; margin-left: auto; margin-right: auto; width: 50%;" src="http://localhost:6161/logo" /> -->
      <div v-show="deviceHelper" style="position:absolute; left:20px; top:20px; z-index:-1; font-size:10px;">
        <input type="checkbox" id="checkbox1" @change="systemConfig['Integration.Mode'] = $event.target.checked ? 'HL7_BYPASS' : 'MANUAL'"><label for="checkbox1">[1] Integration.Mode: {{ systemConfig['Integration.Mode'] }}</label>
        <input type="checkbox" id="checkbox2" @change="systemConfig['DEVICE102'] = $event.target.checked"><label for="checkbox2">[2] DEVICE102: {{ systemConfig['DEVICE102'] }}</label>
        <input type="checkbox" id="checkbox3" @change="systemConfig['DEVICE'] = $event.target.checked ? 145 : 254"><label for="checkbox3">[3] DEVICE: {{ systemConfig['DEVICE'] }}</label>
        <input type="checkbox" id="checkbox4" @change="systemConfig['DEVICE139'] = $event.target.checked"><label for="checkbox4">[4] DEVICE139: {{ systemConfig['DEVICE139'] }}</label>
        <input type="checkbox" id="checkbox5" @change="systemConfig['PDFRemote'] = $event.target.checked"><label for="checkbox5">[5] PDFRemote: {{ systemConfig['PDFRemote'] }}</label>
        <input type="checkbox" id="checkbox6" @change="systemConfig['LogoStyle'] = $event.target.checked"><label for="checkbox6">[6] LogoStyle: {{ systemConfig['LogoStyle'] }}</label>
      </div>

      <template v-if="systemConfig['LogoStyle'] == '0'">
        <!-- custom tailored logo operations -->
        <div v-show="systemConfig['Integration.Mode'] !== 'HL7_BYPASS' && !systemConfig['DEVICE102']" :style="{ 'background-image': 'url(' + hturl('/logo') + ')' }" style="z-index:1; width:400px; border:none !important; background-color:#fff; height:200px; top:145px; left:215px; position:absolute; background-repeat: no-repeat; background-size: 400px; opacity:0.2"
        ></div>

        <div v-show="systemConfig['Integration.Mode'] !== 'HL7_BYPASS' && systemConfig['DEVICE102']" :style="{ 'background-image': 'url(' + hturl('/logo') + ')' }" style="z-index:1; width: 300px; border: medium none !important; background-color: rgb(255, 255, 255); height: 200px; top: 145px; left: 265px; position: absolute; background-repeat: no-repeat; background-size: 300px; opacity: 0.2;"
        ></div>
      </template>

      <!-- testing -->
      <!-- <div style="width:400px; border:none !important; background-color:#fff; height:200px; top:145px; left:215px; position:absolute; background-image: url(http://localhost:6161/logo); background-repeat: no-repeat; background-size: 400px; opacity:1.0"
      ></div> -->

      <div style="padding-left:24mm; padding-top:10mm; padding-bottom:5mm; width:180mm;">
        <table style="float: left;" class="examInfo">
          <tbody>
            <tr>
              <th>{{ $t("report.institution") }}</th>
              <td>:</td>
              <td class="val2">{{ systemConfig.Institution }}</td>
            </tr>
            <tr v-show="systemConfig['Integration.Mode'] === 'HL7_BYPASS'">
              <th>{{ $t("thermal.patient_no") }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.patient.his_patient_id }}</td>
            </tr>
            <tr>
              <th>{{ $t("report.exam_date") }}</th>
              <td>:</td>
              <td class="val2">{{ exam_detail.created }}</td>
            </tr>
            <tr v-show="exam_detail.doctor">
              <th>{{ $t("result_ui.doctor") }}</th>
              <td>:</td>
              <td class="val2">{{ exam_detail.doctor }}</td>
            </tr>
          </tbody>
        </table>
        <table
          style="float:right;"
          class="examInfo"
          v-show="systemConfig['Integration.Mode'] !== 'HL7_BYPASS'"
        >
          <tbody>
            <tr>
              <th>{{ $t("report.name_surname") }}</th>
              <td>:</td>
              <td class="val1">
                <template v-if="systemConfig['DEVICE'] === 145">{{ exam_detail.patient.value2 }}</template>
                <template v-if="systemConfig['DEVICE'] !== 145">{{ exam_detail.patient.name }}<br/>{{ exam_detail.patient.surname }}</template>
              </td>
            </tr>
            <tr>
              <th>{{ $t("report.sex") }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.patient.gender }}</td>
            </tr>
            <tr>
              <th>{{ $t("report.birth_date") }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.patient.birth_date }}</td>
            </tr>
          </tbody>
        </table>
        <div
          style="float:right; margin-right: 50px;"
          class="examInfo"
          v-show="systemConfig['Integration.Mode'] === 'HL7_BYPASS'"
        >
          <img style="height:70px" :src="hturl('/logo')"/>
        </div>
        <div style="clear:both;"></div>
      </div>

      <img v-if="systemConfig['LogoStyle'] == '1'" style="position:absolute; z-index:-1; opacity: 0.2; left:50%; transform: translate(-50%, 0);" src="http://localhost:6161/logo" />

      <svg id="chartResult" />

      <div style="padding-left:24mm; padding-top:5mm; padding-bottom:10mm; width:180mm" v-show="show_uroflowmetry">
        <table style="float: left;" class="examInfo">
          <tbody>
            <tr>
              <th>{{ $t('report.max_flow_rate') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.max_speed }} ml/s</td>
            </tr>
            <tr>
              <th>{{ $t('report.time_to_max_flow') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.max_speed_time }} s</td>
            </tr>
            <tr>
              <th>{{ $t('report.voided_volume') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.total_volume }} ml</td>
            </tr>
            <!-- <tr>
          <th>{{ $t("report.reference_number") }}</th>
          <td>:</td>
          <td class="val2">{{ exam_detail.patient.his_patient_id > 0 ? exam_detail.patient.his_patient_id : '-' }}</td>
            </tr>-->
            <tr v-show="exam_detail.pvr && systemConfig.PVREnabled">
              <th>{{ $t('report.pvr') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.pvr }} ml</td>
            </tr>
          </tbody>
        </table>
        <table style="float:right;" class="examInfo">
          <tbody>
            <tr>
              <th>{{ $t('report.voiding_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.duration }} s</td>
            </tr>
            <tr>
              <th>{{ $t('report.flow_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.flow_time }} s</td>
            </tr>
            <tr></tr>
            <tr>
              <th>{{ $t('report.avg_flow_rate') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.average_speed }} ml/s</td>
            </tr>
            <tr>
              <th>{{ $t('report.delay_time') }}</th>
              <td>:</td>
              <td class="val1">{{ exam_detail.delay_time }} s</td>
            </tr>
          </tbody>
        </table>

        <div class="examInfo" v-show="exam_detail.comment" style="float: left; clear:both; margin-top:10px; margin-bottom:10px;"><span style="font-weight:bold">Doktor görüşü</span>: {{ exam_detail.comment }}</div>

        <div style="clear:both">
          <Nomogram-Dev ref="nomogram"></Nomogram-Dev>
        </div>
      </div>

      <div style="display: flex; position:absolute; clear:both; width:80%; left:10mm; bottom:9mm; border-top:solid 1px #aaa; padding:3mm 10mm 0mm 10mm;">
        <div style="width:185px; border-right:solid 1px #aaa; height:60px; padding-top:10px;" v-show="systemConfig['Integration.Mode'] !== 'HL7_BYPASS'">
          <img src="../assets/logo_arayuz2.png" style="padding-top:0px;" />
        </div>
        <div style="flex:1; padding-left:20px;" :style= "systemConfig['Integration.Mode'] === 'HL7_BYPASS' ? 'padding-top:23px; text-align:center;' : 'padding-top:7px'">
          <span
            style="font-family:Arial; font-size:20px; display:block; padding-bottom:10px;"
          >{{ $t('report.uroflow_report') }}</span>
          <span v-show="systemConfig['DEVICE139']"
            style="font-size:15px;"
          >{{ $t("report.reference_number") }}: {{ exam_detail.extra_info ? exam_detail.extra_info : '-' }}</span>
          <span v-show="systemConfig['Integration.Mode'] !== 'HL7_BYPASS' && !systemConfig['PDFRemote'] && !systemConfig['DEVICE139']"
            style="font-size:15px;"
          >{{ $t("report.reference_number") }}: {{ exam_detail.patient.his_patient_id > 0 ? exam_detail.patient.his_patient_id : '-' }}</span>
          <span v-show="systemConfig['PDFRemote'] && !systemConfig['DEVICE139']"
            style="font-size:15px;"
          >{{ $t("report.reference_number") }}: {{ exam_detail.id > 0 ? exam_detail.id : '-' }}</span>
        </div>
        <div style="width:190px; padding-top:10px; text-align:right" v-show="systemConfig['Integration.Mode'] !== 'HL7_BYPASS'">
          <span
            style="font-family:Arial; font-size:15px; display:block; padding-bottom:10px;"
          >{{ $t('report.print_date') }}</span>
          <span v-show="!systemConfig['DEVICE139']"
            style="font-family:Arial; font-size:15px;"
          >{{ (new Date()).toLocaleDateString() }} {{ (new Date()).toLocaleTimeString() }}</span>
          <span v-show="systemConfig['DEVICE139']"
            style="font-family:Arial; font-size:15px;"
          >{{ customDate }}</span>
        </div>
      </div>
    </div>
  </section>
</template>

<script>

import GenericChart from '../GenericChart'
import NomogramDev from './NomogramDev'
import Settings from '../settings'

export default {
  props: ['title'],
  components: {
    NomogramDev
  },
  data () {
    return {
      exam_detail: { patient: {} },
      systemConfig: {},
      show_uroflowmetry: true,
      customDate: '',
      deviceHelper: false
    }
  },
  methods: {
    hturl (path) {
      return 'http://' + Settings.host + ':6161' + path
    }
  },
  created () {
    var vm = this
    vm.deviceHelper = Settings.deviceHelper

    /*
        <input type="checkbox" id="checkbox1" @change=""><label for="checkbox1">Integration.Mode: {{ systemConfig['Integration.Mode'] }}</label>
        <input type="checkbox" id="checkbox2" @change=" = $event.target.checked"><label for="checkbox2">DEVICE102: {{ systemConfig['DEVICE102'] }}</label>
        <input type="checkbox" id="checkbox3" @change="systemConfig['DEVICE'] = $event.target.checked ? 145 : 254"><label for="checkbox3">DEVICE: {{ systemConfig['DEVICE'] }}</label>
    */

    if (vm.deviceHelper) {
      document.addEventListener('keydown', function (event) {
        if (event.keyCode === 48) {
          vm.deviceHelper = !vm.deviceHelper
        } else if (event.keyCode === 49) {
          document.getElementById('checkbox1').checked = !document.getElementById('checkbox1').checked
          vm.systemConfig['Integration.Mode'] = document.getElementById('checkbox1').checked ? 'HL7_BYPASS' : 'MANUAL'
        } else if (event.keyCode === 50) {
          document.getElementById('checkbox2').checked = !document.getElementById('checkbox2').checked
          vm.systemConfig['DEVICE102'] = document.getElementById('checkbox2').checked
        } else if (event.keyCode === 51) {
          document.getElementById('checkbox3').checked = !document.getElementById('checkbox3').checked
          vm.systemConfig['DEVICE'] = document.getElementById('checkbox3').checked ? 145 : 254
        } else if (event.keyCode === 52) {
          document.getElementById('checkbox4').checked = !document.getElementById('checkbox4').checked
          vm.systemConfig['DEVICE139'] = document.getElementById('checkbox4').checked
        } else if (event.keyCode === 53) {
          document.getElementById('checkbox5').checked = !document.getElementById('checkbox5').checked
          vm.systemConfig['PDFRemote'] = document.getElementById('checkbox5').checked
        } else if (event.keyCode === 54) {
          document.getElementById('checkbox6').checked = !document.getElementById('checkbox6').checked
          vm.systemConfig['LogoStyle'] = document.getElementById('checkbox6').checked
        }
      })
    }
  },
  mounted () {
    console.log('printout mounted')

    /* if (this.$route.query.print || this.$route.query.printdev) {
      console.log('EKLENİYOR')
      var newStyle = document.createElement('style')
      newStyle.appendChild(document.createTextNode("@font-face { font-family: Roboto; src: url('/static/Roboto-Regular.ttf') format('truetype'); }"))

      document.head.appendChild(newStyle)
    } */

    var examId = this.$route.params.examId

    var vm = this

    var chartConfig = {

      width: 730,
      height: 350,
      margin: { top: 8, bottom: 21, left: 70, right: 10 },
      interpolation: 'monotone',
      tickInterval: 1000,
      orientation: 'horizontal',
      axisLabels: 'enabled',
      // tickEvery: 5,
      chartType: 'static',
      invisible_points: 0,
      totalTime: 19000,
      translation: vm.$t,
      EMGEnabled: true,

      tickConfig: {
        verticalTicks: true
      },
      lineStrokeWidth: 1.5 // should match css "stroke-width"
    }

    vm.historyChart = new GenericChart(document.querySelector('svg'), chartConfig)

    Promise.all([
      this.$http.get('http://' + Settings.host + ':6161/' + 'api/exam_detail/' + examId),
      this.$http.get('http://' + Settings.host + ':6161/' + 'api/config')
    ]).then((response) => { // success
      vm.systemConfig = response[1].data
      var exam = response[0].data

      var w = []
      var s = []
      var e = []

      if (exam.weight_array) {
        w = exam.weight_array.split(' ').map(function (item) { return parseFloat(item, 10) })
        s = exam.speed_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      if (exam.emg_array) {
        e = exam.emg_array.split(' ').map(function (item) { return parseFloat(item) })
      }

      var weight = []
      var speed = []
      var emg = []

      for (let i = 0; i < w.length; i++) {
        let t = new Date(i * 1000)
        weight.push([t, w[i]])
        speed.push([t, s[i]])
      }

      for (let i = 0; i < e.length; i++) {
        let t = new Date(i * 100)
        emg.push([t, e[i]])
      }

      vm.exam_detail = exam
      console.log('exam_detail populated')

      vm.exam_detail.patient.birth_date = vm.exam_detail.patient.birth_date.substring(0, 10) // DEVNOTE: Dirty operation
      if (vm.exam_detail.patient.birth_date === '01.01.1900') { vm.exam_detail.patient.birth_date = '-' }

      let genderDict = {
        0: vm.$t('report.female'),
        1: vm.$t('report.male'),
        2: vm.$t('report.unknown')
      }

      vm.exam_detail.patient.gender = genderDict[vm.exam_detail.patient.gender] || vm.exam_detail.patient.gender

      if (exam.weight_array) {
        vm.exam_detail.max_speed = vm.exam_detail.max_speed.toFixed(1)
        vm.exam_detail.average_speed = vm.exam_detail.average_speed.toFixed(1)
        vm.exam_detail.total_volume = vm.exam_detail.total_volume.toFixed(1)

        vm.$refs.nomogram.dots({average_speed: vm.exam_detail.average_speed, max_speed: vm.exam_detail.max_speed, total_volume: vm.exam_detail.total_volume})
      }

      vm.$nextTick(function () {
        vm.historyChart.initDrawing(weight, speed, emg)

        // if (this.$route.query.print) { window.print() }
        if (exam.emg_array && weight.length) {
          console.log('Uroflowmetry+EMG result.')
          vm.show_uroflowmetry = true
          vm.historyChart.emgEnable(true)
        } else if (exam.emg_array && !weight.length) {
          console.log('EMG result.')
          vm.show_uroflowmetry = false
          vm.historyChart.emgEnable(true, true)
        } else {
          console.log('Uroflowmetry result.')
          vm.show_uroflowmetry = true
          vm.historyChart.emgEnable(undefined, false)
        }

        vm.$nextTick(function () {
          console.log('STATIC_CHART_LOADED')
          var m = new Date()
          var dateString =
              ('0' + m.getDate()).slice(-2) + '.' +
              ('0' + (m.getMonth() + 1)).slice(-2) + '.' +
              m.getFullYear() + ' ' +
              ('0' + m.getHours()).slice(-2) + ':' +
              ('0' + m.getMinutes()).slice(-2) + ':' +
              ('0' + m.getSeconds()).slice(-2)
          vm.customDate = dateString
          if (this.$route.query.print === 'yes') {
            var filename = (vm.exam_detail.patient.surname + ' ' + vm.exam_detail.patient.name + ', ' + vm.exam_detail.patient.birth_date + ', ' + vm.exam_detail.created)
            // var tempTitle = document.title
            document.title = filename + '.pdf'
            window.print()
            // document.title = tempTitle // Bu satır eğer olursa windows'taki Chrome'da sorun çıkarıyor. Hemen burasını çalıştırıyor, bir anlamı kalmıyor.
          }
        })
      })

      // vm.historyChart.initDrawing();
    }, (response) => { // error
      console.log(response)
    })
  }
}
</script>

<style>
/* roboto-regular - latin_latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 400;
  src: local("Roboto"), local("Roboto-Regular"),
    url("../assets/fonts/roboto-v18-latin_latin-ext-regular.woff2")
      format("woff2"),
    /* Chrome 26+, Opera 23+, Firefox 39+ */
      url("../assets/fonts/roboto-v18-latin_latin-ext-regular.woff")
      format("woff"); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}
/* roboto-700 - latin_latin-ext */
@font-face {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 700;
  src: local("Roboto Bold"), local("Roboto-Bold"),
    url("../assets/fonts/roboto-v18-latin_latin-ext-700.woff2") format("woff2"),
    /* Chrome 26+, Opera 23+, Firefox 39+ */
      url("../assets/fonts/roboto-v18-latin_latin-ext-700.woff") format("woff"); /* Chrome 6+, Firefox 3.6+, IE 9+, Safari 5.1+ */
}

.examInfo {
  line-height: 12pt;
  border-collapse: separate;
  border-spacing: 0.7mm;
  font-size: 10pt;
}

.examInfo th {
  text-align: left;
  width: 26mm;
  font-weight: bold;
}

.examInfo .val1 {
  width: 140px;
}

.examInfo .val2 {
  width: 250px;
}

#chartResult {
  padding-left: 6mm;
}

#chartResult .axis {
  /*font: 10px sans-serif;*/
  font-size: 7pt;
}

#chartResult .axis path,
#chartResult .axis line1,
#chartResult .axis line2,
#chartResult .axis line3 {
  fill: none;
  /*stroke: #dfdfdf;*/
  shape-rendering: crispEdges;
}

#chartResult .axis--x line, #chartResult .axis--y1 line, #chartResult .axis--y2 line, #chartResult .axis--y3 line {
  /* stroke: #dfdfdf; */
  stroke: #000;
  stroke-dasharray: 1, 3;
  /* fill: none; */
  /* stroke-width: 1.5px; */
  /*stroke-width:1px;*/
}

#chartResult .line1 {
  fill: none;
  /*stroke: steelblue;*/
  stroke: red;
  stroke-width: 2px;
}

#chartResult .line2 {
  fill: none;
  /*stroke: steelblue;*/
  stroke: green;
  stroke-width: 2px;
}

#chartResult .line3 {
  fill: none;
  /*stroke: steelblue;*/
  stroke: none;
  stroke-width: 2px;
}

.sheet { z-index: -2 }

</style>



// WEBPACK FOOTER //
// src/components/PrintoutV1.vue